const learnMore = document.querySelectorAll('.learn-more');
learnMore.forEach(function(element){
  element.addEventListener('click',function(e){
  e.preventDefault();
  fetch(e.target.getAttribute('data-href'))
  .then(function(response) {
      return response.text()
  })
  .then(function(html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, "text/html");
      openModal(html,'quick-view')
      console.log(doc);
  })
});
})

const PlpLearnMore = document.querySelectorAll('.quick-view');
PlpLearnMore.forEach(function(element){
  element.addEventListener('click',function(e){
  e.preventDefault();
  fetch(e.target.getAttribute('data-href'))
  .then(function(response) {
      return response.text()
  })
  .then(function(html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, "text/html");
      openModal(html,'plp-quick-view')
  })

  .then(function(){
    var main_slider = new Glide('.product-slider-wrapper', {
      perView: 1,
      rewind: true
      }).on("run", function(event) {
            
        //$('.product-slider-wrapper iframe-holder iframe').attr('src', '');
      }).on("run.after",
      function(event) { 
        $('.current-slide-number').html(main_slider.index+1); 
  
      }).on("run.offset",
      function(event) { 
        $('.current-slide-number').html(main_slider.index+1); 
      }).mount()
  })
  
});
})

openModal = function(content, css) {
  modal = new tingle.modal({
    // closeMethods: ['overlay', 'button', 'escape'],
    closeLabel: "Close",
    cssClass: [css],
    onOpen: function(){   
      // Uncomment to check if the modal is working
      // console.log('Modal properly loaded');

      // This fixes the bug with profile pictures of the reviewers not loading.
      const imagesNotLoaded = document.querySelectorAll('img[data-oke-reviews-review-id]');
      imagesNotLoaded.forEach((image) =>{
        image.setAttribute('src', image.getAttribute('data-oke-reviews-lazy-image-url'));
      })

      // Tindal main slider
      const tindal_main_slider = new Glide('.product-slider-wrapper', {
        perView: 1,
        rewind: true
      }).mount()

      // Tindal thumbnail slider
      const tindal_thumb_slider = new Glide('.product-slider-thumbnails-wrapper', {
        perView: 4,
        rewind: true
      }).mount()

      const optionsSelector = document.querySelector('[data-single-options-selector]')
      optionsSelector.addEventListener("change", function() {
        const hiddenValuesInput = document.querySelector('[data-selected-variant-values]')
        const variantPriceDisplay = document.querySelector('[data-variant-price-display]')
        const variantPriceCompareDisplay = document.querySelector('[data-variant-price-display] + del')
        const variantPrice = document.querySelector('option[value="' + this.value + '"]')
    
        variantPriceDisplay.innerHTML = variantPrice.dataset.variantPrice
        variantPriceCompareDisplay.innerHTML = `<span class=money>${variantPrice.dataset.variantPriceCompareRaw}</span>`
    
        hiddenValuesInput.value = this.value
      });
      const readMore = document.querySelector('[read-more]')
      readMore.addEventListener('click',function(e){
        e.target.style.display = "none"
        document.querySelector('[quick-view-description]').classList.remove('max-h-24')
      })

      // Slider: Go to a certain index
      document.querySelectorAll('[data-thumnail-index]').forEach((thumbnail, index) => {
        thumbnail.addEventListener('click', () => {
          tindal_main_slider.go('=' + index)
        })
      })
      document.querySelector('[scroll-to-reviews]').addEventListener('click',function(e){
        e.preventDefault()
        const element = document.getElementById("quick-product-reviews")
        element.scrollIntoView({ behavior: 'smooth'})
      })
      const modalAddToCartElement = document.querySelector('[modal-add-to-cart]');

      if (modalAddToCartElement) {
        modalAddToCartElement.addEventListener('click', function(e) {
          e.preventDefault();
          const Cart = window.Rebuy.Cart;
          const addData = {
            id: optionsSelector.value,
            quantity: document.querySelector('.plp-quick-view [name="quantity"]').value ? document.querySelector('.plp-quick-view [name="quantity"]').value : 1,
          };
          Cart.addItem(addData);
        });
      } else {
        console.error('Element with [modal-add-to-cart] attribute not found.');
      }
    },
    onClose: function() {
      modal.destroy()
  },
  });
  modal.setContent(content);
  modal.open();
}